<p-panel [header]="headerMsg | translate" [style]="{margin: '5px'}">
  <app-download-generic-form *ngIf="displayFormToDownload; else showGenerics"
                             [releaseValue]="this.releaseValue"
                             (displayFormToDownload)="this.unsetDisplayFormToDownload( $event )">
  </app-download-generic-form>
  <ng-template #showGenerics>
    <div *ngIf="downloadableList && downloadableList.length > 0">
      <p-table id="dowloadVirtualPrinterForm" [columns]="cols" [value]="downloadableList" dataKey="version" dataKey="release" rowExpandMode="single" >
        <ng-template pTemplate="header" let-columns>
          <tr>
              <th *ngFor="let col of columns"> {{ col.header }} </th>
              <th> Actions </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
          <tr>
            <td *ngFor="let col of columns" >
              {{ rowData[col.field] }}
            </td>
            <td style="text-align: center;">
              <button pButton type="button" [icon]="'fa fa-download'" class="p-button-info" [pRowToggler]="rowData" (click)="setDisplayFormToDownload($event, rowData);"></button>
              <button *ngIf="this.user.admin" pButton type="button" [icon]="'fa fa-trash-o'" class="p-button-danger" (click)="confirmDelete( $event, rowData )"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
          <ng-container *ngIf="this.virtualPrinterType === 'generic'">
            <tr>
              <td [attr.colspan]="columns.length + 1">
                <app-download-generic-form [releaseValue]="rowData.release"></app-download-generic-form>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="this.virtualPrinterType === 'package'">
            <tr>
              <td [attr.colspan]="columns.length + 1">
                <div class="download_virtual_printer">
                  <div class="download_virtual_printer-recette">
                    <table>
                      <tr>
                        <td class="title" colspan="2"> {{ 'VIRTUAL_PRINTER.COMMON.ENVIRONMENT_PRODUCTION'.toUpperCase() | translate }} </td>
                      </tr>
                      <tr>
                        <td>
                          <button pButton type="button" class="download_button" label="( {{ rowData.size_x32_prod }} )" (click)="downloadPackagedVirtualPrinter( $event, rowData, 'Prod', 'x32' )"> <div class="arch"> x32 </div> </button>
                        </td>
                        <td>
                          <button pButton type="button" class="download_button" label="( {{ rowData.size_x64_prod }} )" (click)="downloadPackagedVirtualPrinter( $event, rowData, 'Prod', 'x64' )"> <div class="arch"> x64 </div> </button>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="download_virtual_printer-production">
                    <table>
                      <tr>
                        <td class="title" colspan="2"> {{ 'VIRTUAL_PRINTER.COMMON.ENVIRONMENT_STAGING' | translate }} </td>
                      </tr>
                      <tr>
                        <td>
                          <button pButton type="button" class="download_button" label="( {{ rowData.size_x32_rec }} )" (click)="downloadPackagedVirtualPrinter( $event, rowData, 'Rec', 'x32' )"> <div class="arch"> x32 </div> </button>
                        </td>
                        <td>
                          <button pButton type="button" class="download_button" label="( {{ rowData.size_x64_rec }} )" (click)="downloadPackagedVirtualPrinter( $event, rowData, 'Rec', 'x64' )"> <div class="arch"> x64  </div> </button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </div>
    <div *ngIf="!downloadableList || downloadableList.length < 1">
      <h3>{{noDownloadMsg | translate}}</h3>
    </div>
  </ng-template>
</p-panel>
